<div class="container">
   <ng-container *ngIf="isLoading">
      <app-spinner></app-spinner>
   </ng-container>

   <ng-container *ngIf="!isLoading">
      <div class="mt-4 grid lg:grid-cols-5 gap-6">
         <div>
            <div class="justify-center">
               <img class="max-w-xs w-full rounded-full mb-4"
                  [src]="backendUrl + teacher.profilePic"
                  alt="Profile Picture">
            </div>

            <div *ngIf="teacher.facebook">
               <a mat-button
                  class="w-full mb-2 no-underline"
                  color="primary"
                  [href]="teacher.facebook"
                  target="_blank"
                  rel="noreferrer">
                  <fa-icon [icon]="['fab', 'facebook']"></fa-icon>
                  Facebook
               </a>
            </div>

            <div *ngIf="teacher.instagram">
               <a mat-button
                  class="w-full mb-2 no-underline"
                  color="primary"
                  [href]="teacher.instagram"
                  target="_blank"
                  rel="noreferrer">
                  <fa-icon [icon]="['fab', 'instagram']"></fa-icon>
                  Instagram
               </a>
            </div>

            <div *ngIf="teacher.linkedin">
               <a mat-button
                  class="w-full mb-2 no-underline"
                  color="primary"
                  [href]="teacher.linkedin"
                  target="_blank"
                  rel="noreferrer">
                  <fa-icon [icon]="['fab', 'linkedin']"></fa-icon>
                  Linkedin
               </a>
            </div>

            <div *ngIf="teacher.twitter">
               <a mat-button
                  class="w-full mb-2 no-underline"
                  color="primary"
                  [href]="teacher.twitter"
                  target="_blank"
                  rel="noreferrer">
                  <fa-icon [icon]="['fab', 'twitter']"></fa-icon>
                  Twitter
               </a>
            </div>

            <div *ngIf="teacher.website">
               <a mat-button
                  class="w-full mb-2 no-underline"
                  color="primary"
                  [href]="teacher.website"
                  target="_blank"
                  rel="noreferrer">
                  <fa-icon [icon]="['fas', 'globe']"></fa-icon>
                  Website
               </a>
            </div>

            <div *ngIf="teacher.email">
               <a mat-button
                  class="w-full mb-2 no-underline"
                  color="primary"
                  [href]="'mailto:' + teacher.email"
                  target="_blank"
                  rel="noreferrer">
                  <fa-icon [icon]="['fas', 'at']"></fa-icon>
                  Email
               </a>
            </div>
         </div>

         <div class="lg:col-span-4">
            <div class="color-[#6a6f73] font-bold text-xl">Багш</div>
            <h1 class="text-2xl font-bold leading-5">{{teacher.displayName}}</h1>
            <h3>{{teacher.title}}</h3>
            <h2>About me</h2>
            <p [innerHtml]="teacher.description"></p>
            <app-course-grid [courses]="teacher.courses"
               [maxColumns]="2"
               title="Миний хичээлүүд"
               [showCourseNumber]="true">
            </app-course-grid>
         </div>
      </div>
   </ng-container>
</div>